import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ContactForm from '../ContactFrom/ContactForm'
import icon1 from '../../images/icon/call-calling.svg'
import icon2 from '../../images/icon/icon-sms.svg'
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import Swal from 'sweetalert2';
import tawkManager from '../../utils/tawkManager';

const ContactSection = (props) => {
    const { activeTab = 'contact' } = props;
    const recaptchaRef = useRef();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    // Function to handle callback request
    const handleCallbackRequest = async (e) => {
        e.preventDefault();

        // Get reCAPTCHA value
        const recaptchaValue = recaptchaRef.current.getValue();

        if (!recaptchaValue) {
            Swal.fire({
                icon: 'warning',
                title: 'Captcha Required',
                text: 'Please verify you are not a robot.',
            });
            return;
        }

        // Get form data
        const formData = new FormData(e.target);

        // Construct payload as per user request
        const callbackData = {
            referenceNo: formData.get('customerReference'),
            phoneno: formData.get('mobileNumber'),
            reCaptcha: recaptchaValue,
            frompage: "referncs"
        };

        try {
            // Call the new API endpoint for contact details with reference
            const response = await axios.post(
                'https://tigrispay.com/prod/api/contactus/contactdetailswithreference',
                callbackData,
                {
                    timeout: 10000 // 10 second timeout
                }
            );

            const { response: status, responseCode, data } = response.data;

            if (status === true && responseCode === '00') {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Callback request submitted successfully! We will contact you shortly.',
                    timer: 3000,
                    showConfirmButton: false,
                });

                // Reset form and reCAPTCHA
                e.target.reset();
                recaptchaRef.current.reset();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Request Failed',
                    text: data || 'Failed to submit callback request',
                });
            }
        } catch (error) {
            console.error('Error submitting callback request:', error);

            // Handle different types of errors
            if (error.code === 'ECONNABORTED') {
                Swal.fire({
                    icon: 'error',
                    title: 'Timeout Error',
                    text: 'Request timed out. Please check your internet connection and try again.',
                });
            } else if (error.response) {
                // Server responded with error status
                Swal.fire({
                    icon: 'error',
                    title: 'Server Error',
                    text: error.response.data.data || 'Failed to submit callback request. Please try again.',
                });
            } else if (error.request) {
                // Network error
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'Please check your internet connection and try again.',
                });
            } else {
                // Other error
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'There was an error submitting your request. Please try again.',
                });
            }
        }
    }

    return (
        <div>
            {/* 🔹 Internal CSS for yellow SVG icons */}
            <style>{`
                .yellow-icon {
  filter: brightness(0) saturate(100%) invert(86%) sepia(42%) saturate(3533%) hue-rotate(353deg) brightness(103%) contrast(101%);
}

            `}</style>

            <div className="contact pt-85">
                <div className="container">
                    <div className="row pb-130 mt-none-30 justify-content-center">
                        <div className="col-lg-7 mt-30">
                            <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form " style={{ marginRight: "0px " }}>
                                {activeTab === 'contact' && (
                                    <>
                                        <h2 className="xb-title">Send us a message</h2>
                                        <p className="xb-content">
                                            Have a question? Our team is ready to make your money transfers simple, fast, and stress-free.
                                        </p>
                                        <ContactForm />
                                    </>
                                )}

                                {activeTab === 'callback' && (
                                    <>
                                        <h2 className="xb-title">Request Call Back</h2>
                                        <p className="xb-content">
                                            Leave your details and we'll call you back during our business hours (Mon - Fri: 8.00 AM to 4.00 PM.).
                                        </p>
                                        <form onSubmit={handleCallbackRequest} className="contact-form callback-form">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="customerReference">Customer Reference*</label>
                                                        <div className="input-box">
                                                            <input
                                                                type="text"
                                                                name="customerReference"
                                                                className="form-control"
                                                                placeholder="Enter your customer reference"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="mobileNumber">Mobile Number*</label>
                                                        <div className="input-box">
                                                            <input
                                                                type="tel"
                                                                name="mobileNumber"
                                                                className="form-control"
                                                                placeholder="Enter your mobile number"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12 mt-3">
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        sitekey="6LflOOsrAAAAAEns55E1-c_awAI9hx6KiBBvuq7k"
                                                    />
                                                </div>
                                            </div>

                                            <div className="cp-det-btn mt-20 d-grid">
                                                <button className="cp-btn" type="submit">
                                                    Request Call Back <i className="fal fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                )}

                                {activeTab === 'chat' && (
                                    <div className="chatbot-section">
                                        {/* Title */}


                                        {/* Card */}
                                        <div
                                            className="chatbot-placeholder"
                                            style={{
                                                minHeight: "340px",
                                                background:
                                                    "linear-gradient(135deg, #fffaf0, rgba(255,204,41,0.18))",
                                                border: "1px solid rgba(0,0,0,0.08)",
                                                borderRadius: "18px",

                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                padding: "35px",
                                                textAlign: "center",
                                                position: "relative",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {/* Soft gold orb */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "-60px",
                                                    right: "-60px",
                                                    width: "170px",
                                                    height: "170px",
                                                    background: "#ffcc29",
                                                    borderRadius: "50%",
                                                    opacity: 0.2,
                                                }}
                                            />

                                            {/* Chat Icon */}
                                            <div
                                                className="chatbot-icon"
                                                style={{
                                                    fontSize: "46px",
                                                    marginBottom: "18px",
                                                    background: "#ffcc29",
                                                    color: "#1a1a1a",
                                                    width: "90px",
                                                    height: "90px",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    boxShadow: "0 12px 30px rgba(255,204,41,0.55)",
                                                    animation: "pulse 2s infinite",
                                                }}
                                            >
                                                💬
                                            </div>

                                            {/* Content */}
                                            <h3
                                                style={{
                                                    fontWeight: 700,
                                                    marginBottom: "8px",
                                                    color: "#1a1a1a",
                                                }}
                                            >
                                                Chat with us
                                            </h3>
                                            <p style={{ color: "#555", maxWidth: "420px" }}>
                                                Live chat is available to support you from <b>8 AM to 4 PM</b>. From <b>4 PM to 8 AM</b>, the chatbot will continue to assist you with transfers, fees, and general enquiries.
                                            </p>
                                            {/* CTA */}
                                            <button
                                                className="cp-btn"
                                                onClick={() => {
                                                    if (tawkManager.isReady()) {
                                                        tawkManager.showWidget();
                                                        tawkManager.maximize();
                                                    } else {
                                                        alert("Chat widget is still loading, please try again.");
                                                    }
                                                }}
                                                style={{
                                                    marginTop: "22px",
                                                    padding: "14px 32px",
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    borderRadius: "50px",
                                                    background: "#ffcc29",
                                                    color: "#1a1a1a",
                                                    border: "none",
                                                    boxShadow: "0 12px 25px rgba(255,204,41,0.5)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "translateY(-2px)";
                                                    e.currentTarget.style.boxShadow =
                                                        "0 16px 35px rgba(255,204,41,0.7)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "translateY(0)";
                                                    e.currentTarget.style.boxShadow =
                                                        "0 12px 25px rgba(255,204,41,0.5)";
                                                }}
                                            >
                                                Start Chat <i className="fal fa-comment ms-2"></i>
                                            </button>
                                        </div>

                                        {/* Animation */}
                                        <style>
                                            {`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.06); }
          100% { transform: scale(1); }
        }
      `}
                                        </style>
                                    </div>
                                )}


                            </div>
                        </div>

                        <div className="col-lg-4 mt-30">
                            <div className="item-contact_info ">
                                <div className="xb-item--inner ">
                                    <div className="xb-item--top">
                                        <h3 className="xb-item--title">Contact Info</h3>

                                        <span className="xb-item--hotline" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <i className="fab fa-whatsapp yellow-icon" style={{ fontSize: '24px', marginRight: '15px', marginTop: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <a href="https://wa.me/447436173149" target="_blank" rel="noopener noreferrer" className="contacts-footer" style={{ lineHeight: '1', marginBottom: '5px' }}>+44 743 617 3149</a>
                                                <span style={{ fontSize: '13px', fontWeight: '400', color: '#555' }}>**available for chat only</span>
                                            </div>
                                        </span>

                                        <span className="xb-item--email">
                                            <img src={icon2} alt="Mail Icon" className="yellow-icon" />
                                            <a href="mailto:hello@tigrispay.com" className="contacts-footer">hello@tigrispay.com</a>
                                        </span>

                                        {/* <ul className="social_icons_block list-unstyled ul_li">
                                            <li><Link onClick={ClickHandler} to="/contact" aria-label="Facebook"><i className="fab fa-facebook-f"></i></Link></li>
                                            <li>
                                                <Link onClick={ClickHandler} to="/contact" aria-label="Twitter">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.3872 0H15.9952L10.299 7.20048L17 17H11.7545L7.64298 11.0582L2.94415 17H0.332464L6.42395 9.29688L0 0H5.37853L9.09105 5.43101L13.3872 0ZM12.4711 15.2755H13.9155L4.5917 1.63462H3.0402L12.4711 15.2755Z" fill="#0C111D" />
                                                    </svg>
                                                </Link>
                                            </li>
                                            <li><Link onClick={ClickHandler} to="/contact" aria-label="Linkedin"><i className="fab fa-linkedin-in"></i></Link></li>
                                        </ul> */}
                                    </div>

                                    <div className="contact-info_widget">
                                        <h3 className="xb-title">United Kingdom Office</h3>
                                        <span className="xb-location">
                                            25 Cabot Square, Canary Wharf, London,
                                            England, E14 4QZ.
                                        </span>
                                    </div>

                                    <hr className="breack-line" />

                                    <div className="contact-info_widget">
                                        <h3 className="xb-title">Our Office Open Time</h3>
                                        <span className="xb-location">
                                            Mon - Fri: 8.00 AM to 4.00 PM.

                                        </span>
                                    </div>

                                    {/* <div className="contact-info_widget mt-4" style={{background: '#fff8e6', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #ffc107'}}>
                                        <h3 className="xb-title">📞 Number</h3>
                                        <p>For immediate assistance:</p>
                                        <span className="xb-location">
                                            <strong>Mon-Fri: 8am-4pm</strong><br />
                                            <a href="tel:02030055883" className="contacts-footer">+44 02030055883</a>
                                        </span>
                                    </div> */}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="gmap_canvas bg-light">
                <iframe 
                    title='map' 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.0495335232104!2d-0.09612862300564892!3d51.53065130900406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ca7548b9813%3A0xdd386d3d0f1ebc30!2s20-22%20Wenlock%20Rd%2C%20London%20N1%207GU%2C%20UK!5e0!3m2!1sen!2sin!4v1760514935832!5m2!1sen!2sin">
                </iframe>
            </div> */}
        </div>
    )
}

export default ContactSection;